exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".metadataContainer{width:300px;height:405px;overflow:scroll;background:#aaaa;padding:10px;margin-right:50px;align-content:center}.title{text-align:center;font-size:14px;margin-bottom:10px;font-weight:700}.metadata-fields{display:flex;flex-direction:row}.key{font-weight:700;margin-left:6px}.key,.value{margin-right:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-486d78d9","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MetaDataViewer.vue
// module id = 45
// module chunks = 0